<template>
  <div class="change-question">请选择您遇到的问题类型</div>
</template>

<script>
//询前页头部
export default {
  name: "before-page-header"
};
</script>

<style scoped lang="less">
.change-question {
  padding-left: 20px;
  color: var(--pre-header-text-color);
}
</style>
